import prepareComponent from "@bluframe/grapple/prepareComponent";
import config from "config/site";
import useNewsCard from "hooks/news/useNewsCard";
import { useMemo } from "react";
import News from "./News";
const usePrepareComponent = () => {
    /**
     *  List of news service names from config file.
     */
    const newsServiceNames = useMemo(() => Object.freeze(config.news
        .flatMap((item) => item.rows)
        .map((row) => ({ name: row.name, serviceName: row.serviceName }))), []);
    const newsCards = useMemo(() => newsServiceNames.reduce((acc, { name, serviceName }) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        acc[serviceName] = useNewsCard({ name, serviceName });
        return acc;
    }, {}), [newsServiceNames]);
    return {
        newsCards
    };
};
export default prepareComponent(usePrepareComponent)(News);
